import { CommonModule, DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  ViewChild
} from '@angular/core';

import { LogoutDetailsResponse } from '@hdms/shared/data-access';
import { ButtonBaseClassesType, ButtonModule } from '@hdms/shared/ui-core';
import { AnalyticsService, EnvironmentService, LogoutModule } from '@hdms/shared/util-core';

import { HeaderConfigService } from '../../services';

const LOGOUT_FORM_SELECTOR = '.js-logout-form';

@Component({
  standalone: true,
  selector: 'shrd-pf-ft-header-user-logout',
  templateUrl: './header-user-logout.component.html',
  imports: [CommonModule, ButtonModule, LogoutModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserLogoutComponent {
  @Input() buttonVariant: ButtonBaseClassesType;
  @Input() buttonClasses: string;
  @Input() logoutLabel: string;

  logoutDetails: LogoutDetailsResponse;
  logoutInProgress = false;

  @ViewChild('logoutForm', { read: ElementRef })
  private readonly logoutForm: ElementRef<HTMLFormElement>;

  constructor(
    private readonly configService: HeaderConfigService,
    private readonly cdr: ChangeDetectorRef,
    private readonly env: EnvironmentService,
    private readonly analyticsService: AnalyticsService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  doLogout(): void {
    this.logoutInProgress = true;
    this.analyticsService.sendEvent({
      action: 'Account',
      category: 'UserAccountFlyout',
      label: 'Logout'
    });
    this.env.hostContext ? this.triggerLegacyLogout() : this.fetchLogoutDetails();
  }

  private triggerLegacyLogout(): void {
    this.document.querySelector<HTMLButtonElement>(`${LOGOUT_FORM_SELECTOR} button`)?.click();
  }

  private fetchLogoutDetails(): void {
    this.configService.logoutDetails$.subscribe({
      next: data => {
        this.logoutDetails = data;
        this.cdr.detectChanges();
        this.logoutForm.nativeElement.submit();
      },
      error: _ => {
        this.logoutInProgress = false;
        this.cdr.markForCheck();
      }
    });
  }
}
